import React, { Component } from 'react'
import firebase from 'firebase'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import queryString from 'query-string'

import * as manageEducatorsActionCreators from '../../redux/modules/manageEducators'
import { db } from '../../config/firebaseconfig'
import { ManageStudents } from '../../components/Users'
import initializeManageEducators from '../../helpers/users/initializeManageEducators'
import getSelection from '../../helpers/users/getSelection'
import has from 'mout/object/has'

import superAdminUser from '../../helpers/users/testing/superAdminUser' // Testing
import districtAdmin from '../../helpers/users/testing/districtAdmin'

import getSelectionStudents from '../../helpers/users/getSelectionStudents';
import getParentId from '../../helpers/users/getParentId'
import forceSelectionStudentsByRole from '../../helpers/users/forceSelectionStudentsByRole';

/*

Add students
Add students to classes
Add students by csv upload
Add students using invitation code
Filter students

*/


class ManageStudentsContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      forceDistrictExpanded: false,
      forceSchoolExpanded: false,
      districtNameSearch: '',
    }

    this.closeModal = this.closeModal.bind(this)
    this.openModal = this.openModal.bind(this)
    this.select = this.select.bind(this)
    this.setSearch = this.setSearch.bind(this)
    this.setForceExpanded = this.setForceExpanded.bind(this)
    this.deleteRecord = this.deleteRecord.bind(this)
  }

  componentDidMount() {
  /*
    Hardwired the active user for testing
  */
    this.user = this.props.testUser || districtAdmin
//    this.user = districtAdmin 
    const initActions = {
      initializing: this.props.initializing,
      initializingError: this.props.initializingError,
      initializingSuccess: this.props.initializingSuccess,
      set: {
        districts: this.props.setDistricts,
        schools: this.props.setSchools,
        educators: this.props.setEducators,
        students: this.props.setStudents,
        classes: this.props.setClasses,
      }
    }
    initializeManageEducators(this.user, initActions, this.props.match.params)
  }

  setSearch(searchProp, e) {
    this.setState({[searchProp]: e.target.value})
  }

  closeModal(id) {
    if (!id) {
      this.props.history.push('?')
    } else if (!(typeof id === 'string' || id instanceof String)) {
      this.props.history.push('?')
    } else {
      this.props.history.push(`/users/students/${id}`)
    }
  }

  openModal(modal) {
    this.props.history.push(`?m=${modal}`)
  }

  select(id) {
    this.props.history.push(`/users/students/${id}`)
    if (this.props.districts[id]) {
      this.setState({forceDistrictExpanded: false})
    }
    if (this.props.schools[id]) {
      this.setState({forceDistrictExpanded: false, forceSchoolExpanded: false,})
    }
  }

  setForceExpanded(key, val) {
    this.setState({[key]: val})
  }

  deleteRecord(collectionName, id) {
    this.props.deletingRecord()
    const data = {
      districts: this.props.districts,
      schools: this.props.schools,
      educators: this.props.educators,
      classes: this.props.classes,
    }
    let selectionId
    let match = false
    if (this.props.match.params.activeSelection === id) {
      match = true
      selectionId = getParentId(id, data)
    }
    db.collection(collectionName).doc(id).update({deleted: true})
      .then(() => {
        this.props.deletingRecordSuccess()
        if (selectionId && match) {
          this.props.history.push(`/users/students/${selectionId}`)
        } else if (match) {
          this.props.history.push(`/users/students`)
        } else {
          this.closeModal()
        }
      })
      .catch((err) => this.props.deletingRecordError(err))
    // update groupUAs for: class, teacher, school, district
  }

  render() {
    let modal = ''
    let recordId
    if (this.props.location.search) {
      const query = queryString.parse(this.props.location.search)
      if (query.m) {
        modal = query.m
      }
      if (query.id) {
        recordId = query.id
      }
    }

    let selection
    if (has(this.props, 'match.params.activeSelection') && this.props.districts) {
      const data = {
        districts: this.props.districts,
        schools: this.props.schools,
        students: this.props.students,
      }
      selection = getSelectionStudents(this.props.match.params.activeSelection, data)
      this.user ? selection = forceSelectionStudentsByRole(this.user, selection) : null
    } else {
      selection = {
        district: '',
        school: '',
        student: '',
      }
      this.user ? selection = forceSelectionStudentsByRole(this.user, selection) : null
    }
    return (
      <ManageStudents
        isInitializing={this.props.isInitializing}
        isInitializingError={this.props.isInitializingError}
        districts={this.props.districts}
        schools={this.props.schools}
        educators={this.props.educators}
        classes={this.props.classes}
        students={this.props.students}
        user={this.user}
        selection={selection}
        modal={modal}
        openModal={this.openModal}
        closeModal={this.closeModal}
        select={this.select}
        forceDistrictExpanded={this.state.forceDistrictExpanded}
        filters={this.props.filters}
        districtNameSearch={this.state.districtNameSearch}
        setFilter={this.props.setFilter}
        setSearch={this.setSearch}
        setForceExpanded={this.setForceExpanded}
        forceSchoolExpanded={this.state.forceSchoolExpanded}
        recordId={recordId}
        deleteRecord={this.deleteRecord}
        isDeleting={this.props.isDeleting}
        isDeletingError={this.props.isDeletingError}
      />
    )
  }
}

export default connect(
  (state) => ({
    isInitializing: state.manageEducators.isInitializing,
    isInitializingError: state.manageEducators.isInitializingError,
    districts: state.manageEducators.districts,
    schools: state.manageEducators.schools,
    educators: state.manageEducators.educators,
    classes: state.manageEducators.classes,
    students: state.manageEducators.students,
    selection: state.manageEducators.selection,
    filters: state.manageEducators.filters,
    isDeleting: state.manageEducators.isDeleting,
    isDeletingError: state.manageEducators.isDeletingError,
    testUser: state.users.testUser,
  }),
  (dispatch) => bindActionCreators(manageEducatorsActionCreators, dispatch)
)(ManageStudentsContainer)


// WEBPACK FOOTER //
// ./src/containers/Users/ManageStudentsContainer.js